<div class="maintenance tw-flex tw-h-screen tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-text-center">
  <p class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]">خطایی در سامانه رخ داده است.</p>
  <img alt="خطایی در سامانه رخ داده است." class="!tw-my-4" src="assets/images/maintenance.png"/>
  <button smsir-button variant="secondary" size="sm" type="button" (click)="retry()">
    تلاش مجدد
  </button>
</div>
